import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { CustomChip } from '../../../components/chip/Chip';
import { CustomInfoContainer } from '../../../components/customInfoContainer/CustomInfoContainer';
import { formatCurrency } from '../../../utils/mathUtils';
import InfoRow from '../../MisVisitasCreation/components/components/InfoRow/InfoRow';

moment.locale('es');

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const PreLiquidacionInfoProfesional = ({
    profesional = {},
    mesLiquidado,
    liquidacionMesAnterior = 0,
    observacionRechazo
}) => {
    const mesAnterior = mesLiquidado
        ? capitalize(moment().month(mesLiquidado - 2).format('MMMM'))
        : '';

    return (
        <CustomInfoContainer sx={{ whiteSpace: 'break-spaces' }}>
            <Box display="flex" gap={2.25} alignItems="center">
                <InfoRow
                    label='Id profesional: '
                    value={profesional.id ?? 'N/A'}
                    sx={{ flexDirection: 'row', mb: 0 }}
                    invert
                />
                <InfoRow
                    label='#SAP '
                    value={profesional.sap ?? 'N/A'}
                    sx={{ flexDirection: 'row', mb: 0 }}
                    invert
                />
                <InfoRow
                    label='Profesional: '
                    value={profesional.profesional ?? 'N/A'}
                    sx={{ flexDirection: 'row', mb: 0 }}
                    invert
                />

                {profesional.tieneHonorarioFidelizado && (
                    <CustomChip label='Fidelizado' />
                )}

                {observacionRechazo && (
                    <Box display='flex' alignItems='center' gap={0.5}>
                        <CustomChip isRed label='Rechazado' />
                        <Tooltip title={observacionRechazo} arrow>
                            <InfoOutlinedIcon className='edit-icon' />
                        </Tooltip>
                    </Box>
                )}
            </Box>

            {mesAnterior && (
                <InfoRow
                    label={`Liquidación mes ${mesAnterior}: `}
                    value={formatCurrency(liquidacionMesAnterior ?? 0)}
                    invert
                    sx={{
                        flex: 1,
                        flexDirection: 'row',
                        mb: 0,
                        justifyContent: 'flex-end'
                    }}
                />
            )}
        </CustomInfoContainer>
    );
};